import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UploadDocument} from '@services/resource/upload-document';
import {DocumentService} from '@services/document.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FileCheckService} from '@services/file-check.service';
import {UploadDocumentType} from '@services/resource/upload-document-type';
import {ContinuousActionComponent} from '@widgets/continuous-action/continuous-action.component';
import {Subject} from 'rxjs';
import {filter} from 'rxjs/operators';
import {ClientConfig} from '@app/client-config';
import {none, Option, some} from 'fp-ts/lib/Option';
import {MarkantElementsModule} from '@markant/elements-angular';
import {DropzoneComponent} from '@dashboard/dropzone/dropzone.component';
import {MatDivider} from '@angular/material/divider';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-pitch-deck',
  templateUrl: './pitch-deck.component.html',
  styleUrls: ['./pitch-deck.component.scss'],
  standalone: true,
  imports: [CommonModule, MarkantElementsModule, ContinuousActionComponent, DropzoneComponent, MatDivider],
})
export class PitchDeckComponent implements OnInit {
  @Input() productId: string;
  @Input() currentPitchDeck: UploadDocument | undefined;
  @Input() disabled = false;

  /*
   * returns either 'some(document)' (a document that should be uploaded) or
   * 'none' (meaning that there should be not pitch deck / the user deleted
   * the pitch deck). */
  @Output() pitchDeckChanged: EventEmitter<Option<UploadDocument>> = new EventEmitter();

  @ViewChild(ContinuousActionComponent, {static: true})
  continuous: ContinuousActionComponent;

  private readonly newFile$: Subject<File> = new Subject();

  public readonly maxFileSize = ClientConfig.maxDocumentSize;

  constructor(
    private readonly snackBar: MatSnackBar,
    private readonly documentService: DocumentService,
    private readonly fileCheckService: FileCheckService,
  ) {}

  ngOnInit() {
    this.newFile$
      .pipe(
        filter((file) => {
          const errors = this.fileCheckService.checkFile(file, ['application/pdf'], ClientConfig.maxDocumentSize);
          errors.forEach((e) => this.snackBar.open(e.message, 'Schließen', {duration: 6000}));
          return errors.length === 0;
        }),
        this.continuous.actions((file) => this.documentService.create(file, UploadDocumentType.PITCHDECK, this.productId)),
      )
      .subscribe(
        (doc: UploadDocument) => {
          this.currentPitchDeck = doc;
          this.pitchDeckChanged.emit(some(this.currentPitchDeck));
        },
        () => this.snackBar.open('Netzwerkfehler beim Hochladen', 'Schließen', {duration: 6000}),
      );
  }

  handleNewFiles(fileList: FileList) {
    if (fileList.length < 1) {
      return;
    }
    this.newFile$.next(fileList[0]);
  }

  delete() {
    this.pitchDeckChanged.emit(none);
  }
}
